(function () {
    /********************* Setup *********************/

    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // the inline add to cart button and the mobile sticky bar's copy of it, always kept in the
    // same state. the copy for each state comes from the section settings, which liquid renders
    // onto the inline button alone
    const atcButtons = [...section.querySelectorAll(".productV3ATC")];
    const atcSettings = atcButtons[0].dataset;

    const product = JSON.parse(section.querySelector(".productV3JSON").textContent);

    // the starting variant is picked in liquid, from there every change resolves a new one
    let activeVariant = JSON.parse(section.querySelector(".productV3VariantJSON").textContent);

    // the main option selects, in product option order — the additional charm selects carry their
    // own class so they never land in here and skew the variant lookup
    const optionSelects = [...section.querySelectorAll(".productV3OptionsSelect")];

    // select-diamond rings hand their diamond, and part of their add to cart, to the unbridaled
    // app. it is boxed up in its own element - see snippets/unbridaled-diamond.liquid
    const unbridaled = section.querySelector("unbridaled-diamond");

    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /********************* Wishlist *********************/

    const wishButton = section.querySelector(".productV3VisualWish");

    // fill or empty the heart, the fill is the only confirmation the product was saved
    function setWish(wished) {
        let label = "Add to wishlist";

        if (wished) {
            label = "Remove from wishlist";
        }

        wishButton.classList.toggle("active", wished);
        wishButton.setAttribute("aria-pressed", wished);
        wishButton.setAttribute("aria-label", label);
    }

    // paint the new state straight away, the wishlist api call runs behind it
    function toggleWish() {
        const wished = !wishButton.classList.contains("active");
        setWish(wished);

        if (wished) {
            addToWishList(wishButton.dataset.product);
            return;
        }

        removeFromWishlist(wishButton.dataset.product);
    }

    // a guest has no wishlist to read or write, liquid renders them a link to log in instead of
    // the toggle, so there is nothing to bind
    if (customerID) {
        wishButton.addEventListener("click", toggleWish);

        // the wishlist lives on our api, so the saved state can only be painted once it lands
        (async () => {
            const wishlist = await getWishList();
            setWish(wishlist.includes(wishButton.dataset.handle));
        })();
    }

    /********************* Product Swiper *********************/

    const visual = section.querySelector(".productV3VisualSwiper");
    const mobile = window.matchMedia("(max-width: 1000px)");
    let productSwiper = null;

    function initSwiper() {
        productSwiper = new Swiper(visual, {
            slidesPerView: 1.3,
            spaceBetween: 0,
            loop: true,
            autoHeight: true,
            breakpoints: {
                1000: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                }
            },
            on: {
                slideChange: function () {
                    // leaving a slide drops whatever it was doing — a playing video, a live zoom
                    section.querySelectorAll(".productV3VisualSwiperSlide video").forEach(video => video.pause());
                    section.querySelectorAll(".productV3VisualSwiperSlide.zoomed").forEach(slide => clearZoom(slide));
                }
            }
        });
    }

    // init on load and whenever the viewport crosses the breakpoint
    if (mobile.matches) {
        initSwiper();
    }

    mobile.addEventListener("change", function (event) {
        if (event.matches) {
            initSwiper();
            return;
        }

        // destroy the instance and clean up the styles swiper added to the slides
        productSwiper.destroy(true, true);
        productSwiper = null;
    });

    // clicking a video slide hands it over to the native controls. delegated, because swiper's
    // loop clones the slides and re-clones them every time it is rebuilt
    visual.addEventListener("click", function (event) {
        const slide = event.target.closest(".productV3VisualSwiperSlide");
        const video = slide?.querySelector("video");

        if (!video) {
            return;
        }

        slide.querySelector(".productV3VisualSwiperSlidePlay")?.remove();
        video.controls = true;
        video.play();
    });

    /********************* Gallery Show More *********************/

    // desktop stacks the first six slides and holds the rest behind the toggle. CSS drops the cap
    // below the breakpoint, so the button is only ever on screen on desktop
    const visualRoot = section.querySelector(".productV3Visual");
    const visualMore = section.querySelector(".productV3VisualMore");

    visualMore?.addEventListener("click", function () {
        const expanded = visualRoot.classList.toggle("expanded");

        let label = "Show more";
        if (expanded) {
            label = "Show less";
        }

        visualMore.setAttribute("aria-expanded", expanded);
        visualMore.querySelector(".productV3VisualMoreText").textContent = label;
    });

    /********************* Image Zoom *********************/

    // video slides have nothing to zoom
    function zoomableSlide(target) {
        const slide = target.closest(".productV3VisualSwiperSlide");

        if (!slide || !slide.querySelector(".productV3VisualSwiperSlideImage")) {
            return null;
        }

        return slide;
    }

    // the displayed image is only sized for its box, so swap in the 2x source the first time a
    // slide is zoomed. preloading it means the swap never flashes a half-drawn image
    function loadZoomImage(image) {
        const zoomSrc = image.dataset.zoom;

        if (!zoomSrc) {
            return;
        }

        delete image.dataset.zoom;

        const preload = new Image();
        preload.addEventListener("load", function () {
            image.src = zoomSrc;
        });
        preload.src = zoomSrc;
    }

    // point the transform origin at the pointer, as a percentage of the image. the scaled image
    // always covers the box from any origin between 0% and 100%, so clamping to that range clamps
    // the pan to the image edges, no overflow and no blank space
    function panZoom(slide, clientX, clientY) {
        const rect = slide.getBoundingClientRect();
        const originX = Math.min(Math.max((clientX - rect.left) / rect.width * 100, 0), 100);
        const originY = Math.min(Math.max((clientY - rect.top) / rect.height * 100, 0), 100);

        slide.querySelector(".productV3VisualSwiperSlideImage").style.transformOrigin = `${originX}% ${originY}%`;
    }

    function clearZoom(slide) {
        slide.classList.remove("zoomed");
    }

    // a click zooms in at the point clicked and a second one zooms back out. on desktop the +
    // icon is the affordance for it, on mobile the same handler covers tap to zoom. swiper
    // swallows the click after a swipe, so this only fires on a genuine tap
    visual.addEventListener("click", function (event) {
        const slide = zoomableSlide(event.target);

        if (!slide) {
            return;
        }

        if (slide.classList.contains("zoomed")) {
            clearZoom(slide);
            return;
        }

        loadZoomImage(slide.querySelector(".productV3VisualSwiperSlideImage"));
        panZoom(slide, event.clientX, event.clientY);
        slide.classList.add("zoomed");
    });

    // once zoomed, the pan follows the cursor
    visual.addEventListener("mousemove", function (event) {
        const slide = zoomableSlide(event.target);

        if (!slide || !slide.classList.contains("zoomed")) {
            return;
        }

        panZoom(slide, event.clientX, event.clientY);
    });

    // moving off the image drops the zoom
    visual.addEventListener("mouseout", function (event) {
        const slide = zoomableSlide(event.target);

        // ignore moves between the slide's own children, only a real exit unzooms
        if (!slide || slide.contains(event.relatedTarget)) {
            return;
        }

        clearZoom(slide);
    });

    /********************* Variant Image *********************/

    // liquid marks the first plain image as the slot the active variant's image takes over, and
    // holds the gallery image it started as so a variant with no image of its own can put it back
    const slot = section.querySelector("[data-variant-image]");
    const galleryImage = {
        src: slot?.getAttribute("src"),
        zoom: slot?.dataset.zoom,
        ratio: slot?.style.aspectRatio,
    };

    function updateVariantImage() {
        if (!slot) {
            return;
        }

        const featured = activeVariant.featured_image;
        let image = galleryImage;

        if (featured) {
            image = {
                src: `${featured.src}&width=1000`,
                zoom: `${featured.src}&width=2000`,
                ratio: `${featured.width} / ${featured.height}`,
            };
        }

        // swiper's loop clones the slot, so every copy of it gets the swap
        section.querySelectorAll("[data-variant-image]").forEach(function (element) {
            element.src = image.src;
            element.dataset.zoom = image.zoom;
            element.style.aspectRatio = image.ratio;

            // a slot left zoomed would still be showing the old image at 2x
            clearZoom(element.closest(".productV3VisualSwiperSlide"));
        });

        // only pull the carousel over when there is a variant image to show, and the clones carry
        // the slide index of the original so whichever copy comes back is the right target
        if (!featured) {
            return;
        }

        const slotSlide = section.querySelector("[data-variant-image]").closest(".productV3VisualSwiperSlide");
        productSwiper?.slideToLoop(Number(slotSlide.dataset.swiperSlideIndex));
    }

    /********************* Reviews Link *********************/

    // the stamped widget is its own app block further down the page, so the jump is a scroll
    // rather than navigation. the link only renders once the product has reviews
    section.querySelector(".productV3HeaderReviews")?.addEventListener("click", function (event) {
        event.preventDefault();
        document.querySelector("#stamped-main-widget")?.scrollIntoView({behavior: "smooth"});
    });

    /********************* Update Product *********************/

    // variant ids priced on request, which hides the price and turns add to cart into a request
    const priceRequestIDs = JSON.parse(section.querySelector(".productV3PriceRequestJSON").textContent);

    function isPriceRequest() {
        return !!activeVariant && priceRequestIDs.includes(String(activeVariant.id));
    }

    // whatever the button says, it says on both of them
    function setATC(text, disabled) {
        atcButtons.forEach(button => {
            button.textContent = text;
            button.disabled = disabled;
        });
    }

    // low stock message above the add to cart button, exact count for 1 or 2, vague from 3 up
    function updateStockLeft(status) {
        const stockLeft = section.querySelector(".productV3StockLeft");
        const stockCount = status.on_hand_minus_committed_inventory;

        // hide when nothing is on hand or the variant can't be bought
        if (status.sold_out || status.error || !(stockCount > 0)) {
            stockLeft.classList.remove("active");
            return;
        }

        let label = "Only a few left!";
        if (stockCount <= 2) {
            label = `Only ${stockCount} Left!`;
        }

        stockLeft.textContent = label;
        stockLeft.classList.add("active");
    }

    async function updateProduct() {

        // wait for a full set of options before looking up a variant
        const pendingOption = optionSelects.find(select => !select.value);

        if (pendingOption) {
            activeVariant = null;
            setATC(`Select ${pendingOption.dataset.option}`, true);
            updateStockLeft({});
            return;
        }

        activeVariant = await getActiveVariant();

        // no variant matches the picked combination
        if (!activeVariant) {
            setATC("Not Available", true);
            updateStockLeft({});
            return;
        }

        updateVariantImage();

        // resolve every ticked charm row so the price below and the cart payload agree
        charmVariants = await getCharmVariants();
        const charmsTotal = charmVariants.reduce((total, variant) => total + variant.price, 0);

        // the charms are priced into the header, so it reads as the total the cart will show
        const headerPrice = section.querySelector(".productV3HeaderPrice");
        headerPrice.classList.toggle("priceRequest", isPriceRequest());

        /*
         * Once the unbridaled app has rendered it writes the header price itself, as one total for
         * the ring and the diamond the shopper picked - a figure the section has no way to work
         * out. So the price is left to it, and the setting's own compare at is cleared with it,
         * since a strike through that leaves the diamond out would read as wrong against that
         * total. Until the app is there, the section prices the ring as usual.
         */
        if (!unbridaled?.ownsPrice) {
            headerPrice.querySelector(".productV3HeaderPriceReal").textContent = price(activeVariant.price + charmsTotal, true);

            let compare = "";
            if (activeVariant.compare_at_price > activeVariant.price) {
                compare = price(activeVariant.compare_at_price + charmsTotal, true);
            }
            headerPrice.querySelector(".productV3HeaderPriceCompare").textContent = compare;
        } else {
            headerPrice.querySelector(".productV3HeaderPriceCompare").textContent = "";
        }

        // ims is the source of truth for stock, the element refetches off the sku. unbridaled
        // rings are not stocked there, so they go without a status and the app decides
        let status = {};

        if (!unbridaled) {
            section.querySelector(".productV3OptionsStatus").dataset.sku = activeVariant.sku;
            status = await getInventoryStatus(activeVariant.sku);
        }

        updateStockLeft(status);

        // a ticked charm row with an unpicked option holds the button, same as a main option
        const pendingCharm = charmRows.map(missingCharmSelect).find(Boolean);

        if (isPriceRequest()) {
            setATC(atcSettings.priceRequestText, false);
        } else if (status.sold_out || status.error) {
            setATC(atcSettings.soldOutText, true);
        } else if (pendingCharm) {
            setATC(`Select ${pendingCharm.dataset.option}`, true);
        } else {
            setATC(atcSettings.addToCartText, false);
        }

        // keep the variant in the url so the selection survives a refresh
        const url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    optionSelects.forEach(function (select) {
        select.addEventListener("change", updateProduct);
    });

    // the unbridaled app mounts long after this script runs and takes the header price with it, so
    // repaint once it lands to hand the price over
    unbridaled?.addEventListener("unbridaled:mounted", updateProduct);

    // the variant behind the current main selection
    async function getActiveVariant() {
        if (product.variants.length === 1) {
            return product.variants[0];
        }

        return findVariant(optionSelects.map(select => select.selectedOptions[0]));
    }

    /**
     * Resolves a variant from one chosen <option> element per product option, in product option order.
     * Shared by the main selection and by each additional charm.
     * @param {HTMLOptionElement[]} optionElements One option element per product option
     * @returns {Promise<Object|undefined>} The matching variant
     */
    async function findVariant(optionElements) {
        // the product json is capped at Shopify's 250 variants, past that the server resolves it
        if (product.variants.length >= 250) {
            const optionIDs = optionElements.map(option => option.dataset.id);
            const response = await fetch(`${window.location.pathname}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());
            return response.active_variant;
        }

        const options = optionElements.map(option => option.value);
        return product.variants.find(variant =>
            JSON.stringify(variant.options) === JSON.stringify(options)
        );
    }

    /********************* Additional Charms *********************/

    // option names that identify each axis, matched as substrings against the option name
    const CHAIN_OPTION_NAMES = ["chain", "style"];

    // options that describe the piece as a whole rather than the individual charm, so they
    // ride along with the main selection instead of being picked again on every charm
    const CARRIED_OPTION_NAMES = ["size"];

    const MAX_ADDITIONAL_CHARMS = 10;

    // only present when the product has the show_additional_charm metafield set, and there is
    // nothing to duplicate on a product with no options to match a second variant against
    const additional = optionSelects.length ? section.querySelector(".productV3Additional") : null;

    // whether an option select's name contains any of the given lowercase words
    function matchesOption(select, names) {
        const name = select.dataset.option.toLowerCase();
        return names.some(candidate => name.includes(candidate));
    }

    // the chain option's no chain value — "Charm Only", "Pendant Only", "Charm Pair Only".
    // products that don't name one fall back to the first value, which is the bare charm
    function noChainOption(select) {
        const values = [...select.options].filter(option => option.value);
        return values.find(option => /\bonly\b/i.test(option.value)) || values[0];
    }

    // values go back into markup as attributes, so escape what we read off the dom
    function escapeValue(value) {
        return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    // the chain axis gets pinned to its no chain value so a second chain isn't charged
    const chainSelect = optionSelects.find(select => matchesOption(select, CHAIN_OPTION_NAMES));

    // every remaining option describes the individual charm, so each one gets its own select on
    // each row — the charm itself, and things like Boy or Girl that vary from charm to charm.
    // a product whose only option is the chain axis has nothing to pick, leaving this empty and
    // the rows as a bare checkbox
    const charmSelects = optionSelects.filter(select =>
        select !== chainSelect && !matchesOption(select, CARRIED_OPTION_NAMES)
    );

    // one entry per ticked row, keyed by option name and holding the chosen value
    let charmRows = [];

    // the resolved variant behind each completed charm row, rebuilt on every updateProduct
    let charmVariants = [];

    // the first per-charm option a row hasn't picked yet, which is what makes it incomplete
    function missingCharmSelect(row) {
        return charmSelects.find(select => !row[select.dataset.option]);
    }

    // one select per per-charm option, so a Lulu & Lox charm picks its own Boy or Girl. the two
    // wrappers around them are the grid track the expand animation grows, and the clip inside it
    function charmSelectsHTML(row, expanding) {
        if (!charmSelects.length) {
            return "";
        }

        let selectsHTML = "";

        charmSelects.forEach(source => {
            const name = source.dataset.option;
            const value = row[name] || "";

            // carry the shopper's pick across the re-render
            let optionsHTML = "";
            [...source.options].forEach(option => {
                if (!option.value) {
                    return;
                }

                let selected = "";
                if (option.value === value) {
                    selected = " selected";
                }

                optionsHTML += `<option value="${escapeValue(option.value)}" data-id="${option.dataset.id}"${selected}>${escapeValue(option.textContent.trim())}</option>`;
            });

            let placeholderSelected = " selected";
            if (value) {
                placeholderSelected = "";
            }

            selectsHTML += `
                <select class="productV3AdditionalRowSelect" data-option="${escapeValue(name)}" aria-label="Select additional ${escapeValue(name)}" autocomplete="off">
                    <button>
                        <selectedcontent></selectedcontent>
                    </button>
                    <option value=""${placeholderSelected} hidden>Select ${escapeValue(name)}</option>
                    ${optionsHTML}
                </select>
            `;
        });

        let expandingClass = "";
        if (expanding) {
            expandingClass = " expanding";
        }

        return `
            <div class="productV3AdditionalRowBody${expandingClass}">
                <div class="productV3AdditionalRowBodyWrap">
                    ${selectsHTML}
                </div>
            </div>
        `;
    }

    // expandingIndex is the row just ticked, the one row whose selects animate open. the trailing
    // checkbox that replaces it is new too, so it expands alongside them
    function renderCharms(expandingIndex = null) {
        if (!additional) {
            return;
        }

        // a trailing row with nothing picked is the empty checkbox that invites the next charm
        const rows = [...charmRows];
        if (rows.length < MAX_ADDITIONAL_CHARMS) {
            rows.push(null);
        }

        let html = "";

        rows.forEach((row, index) => {
            let checked = "";
            let selectsHTML = "";

            if (row) {
                checked = " checked";
                selectsHTML = charmSelectsHTML(row, index === expandingIndex);
            }

            let expandingClass = "";
            if (!row && expandingIndex !== null) {
                expandingClass = " expanding";
            }

            html += `
                <div class="productV3AdditionalRow${expandingClass}" data-index="${index}">
                    <label class="productV3AdditionalRowToggle">
                        <input class="productV3AdditionalRowToggleInput" type="checkbox"${checked}>
                        <span class="productV3AdditionalRowToggleText">Add additional charm</span>
                    </label>
                    ${selectsHTML}
                </div>
            `;
        });

        additional.innerHTML = html;
    }

    /**
     * Resolves every completed charm row to its own variant. The charm option takes the row's
     * value, the chain option is pinned to its no chain value, and every other option (size,
     * boy or girl) mirrors what the shopper already picked.
     * @returns {Promise<Object[]>} One variant per completed row
     */
    async function getCharmVariants() {
        if (!additional) {
            return [];
        }

        const lookups = [];

        charmRows.forEach(row => {
            if (missingCharmSelect(row)) {
                return;
            }

            const optionElements = optionSelects.map(select => {
                if (charmSelects.includes(select)) {
                    return [...select.options].find(option => option.value === row[select.dataset.option]);
                }

                if (select === chainSelect) {
                    return noChainOption(select);
                }

                return select.selectedOptions[0];
            });

            if (optionElements.some(option => !option)) {
                return;
            }

            lookups.push(findVariant(optionElements));
        });

        const variants = await Promise.all(lookups);
        return variants.filter(Boolean);
    }

    // one delegated handler for the whole block, so re-rendering never restacks listeners
    additional?.addEventListener("change", async function (event) {
        const row = event.target.closest(".productV3AdditionalRow");

        if (!row) {
            return;
        }

        const index = Number(row.dataset.index);

        if (event.target.matches(".productV3AdditionalRowToggleInput")) {
            let expandingIndex = null;

            // only the trailing checkbox adds a row, which is also what holds the cap
            if (event.target.checked && index === charmRows.length) {
                charmRows.push({});
                expandingIndex = index;
            }

            // unticking drops that row and re-numbers the rest
            if (!event.target.checked) {
                charmRows.splice(index, 1);
            }

            renderCharms(expandingIndex);
            await updateProduct();
            return;
        }

        // picking only needs state, a re-render would tear the open select away
        charmRows[index][event.target.dataset.option] = event.target.value;
        await updateProduct();
    });

    // the class only has to survive the animation, and the overflow clip it carries would
    // otherwise trim the focus ring off a select
    additional?.addEventListener("animationend", function (event) {
        event.target.classList.remove("expanding");
    });

    /********************* Engraving *********************/

    section.querySelectorAll(".productV3EngravingItemBodyInput").forEach(function (input) {

        // the counter beside the input tracks how much of the allowance is used, and an engraving
        // with no character limit renders no counter
        const count = input.parentElement.querySelector(".productV3EngravingItemBodyCount");

        if (!count) {
            return;
        }

        function updateCount() {
            count.textContent = `${input.value.length}/${input.maxLength}`;
        }

        input.addEventListener("input", updateCount);

        // a value the browser restored on back navigation should not read 0
        updateCount();
    });

    /********************* Product ATC *********************/

    async function addToCart(event) {

        // the app only intercepts the button it tagged, so the sticky bar's copy goes through that
        // one rather than adding the ring on its own and leaving the diamond behind
        if (unbridaled && event.currentTarget !== atcButtons[0]) {
            atcButtons[0].click();
            return;
        }

        // priced on request, so collect the shopper's details instead of adding to the cart
        if (isPriceRequest()) {
            openPricing();
            return;
        }

        atcButtons.forEach(button => button.classList.add("loading"));

        // the main variant first, then one line per additional charm, in the order they were added
        const items = [{
            quantity: 1,
            id: activeVariant.id,
        }];

        // filled in engravings ride along as line item properties, keyed by the input name
        const properties = {};

        section.querySelectorAll(".productV3EngravingItemBodyInput").forEach(function (input) {
            const engraving = input.value.trim();

            if (!engraving) {
                return;
            }

            properties[input.name] = engraving;
        });

        // by the time this runs the app has already added the diamond and clicked the button a
        // second time, leaving the ring's properties on its form - _grouping among them, which is
        // what pairs the two line items in the cart
        if (unbridaled) {
            await customElements.whenDefined("unbridaled-diamond");
            Object.assign(properties, unbridaled.properties);
        }

        if (Object.keys(properties).length > 0) {
            items[0].properties = properties;
        }

        charmVariants.forEach(variant => {
            items.push({
                quantity: 1,
                id: variant.id,
            });
        });

        await addProduct({items: items});

        atcButtons.forEach(button => button.classList.remove("loading"));
        await openCart();
    }

    atcButtons.forEach(function (button) {
        button.addEventListener("click", addToCart);
    });

    /********************* Sticky ATC *********************/

    // the mobile bar rides in once the inline button has scrolled off the top of the viewport,
    // and leaves again the moment the real one is back in view. a button still below the fold
    // has not been scrolled past, so it stays away until then
    const sticky = section.querySelector(".productV3Sticky");

    new IntersectionObserver(function (entries) {
        const inline = entries[0];
        sticky.classList.toggle("active", !inline.isIntersecting && inline.boundingClientRect.top < 0);
    }).observe(atcButtons[0]);

    /********************* Pricing Request *********************/

    // the dialog that collects the request, only rendered when a variant is priced on request
    const pricing = section.querySelector(".productV3Pricing");

    // updateProduct keeps activeVariant current, so there is nothing to re-resolve here
    function openPricing() {
        if (!pricing) {
            return;
        }

        // the product title is already in the markup, the variant only reads well when it has options
        if (!product.has_only_default_variant) {
            pricing.querySelector(".productV3PricingTxtVariant").textContent = activeVariant.title;
        }

        pricing.showModal();
        document.body.classList.add("noScroll");
    }

    // close fires for the button, the backdrop and escape, so the scroll lock lifts in one place
    pricing?.addEventListener("close", function () {
        document.body.classList.remove("noScroll");
    });

    pricing?.querySelector(".productV3PricingClose").addEventListener("click", function () {
        pricing.close();
    });

    // the inner panel swallows its own clicks, so a click on the dialog itself is the backdrop
    pricing?.addEventListener("click", function (event) {
        if (event.target === pricing) {
            pricing.close();
        }
    });

    pricing?.querySelector(".productV3PricingForm").addEventListener("submit", async function (event) {
        event.preventDefault();

        const submit = this.querySelector(".productV3PricingFormSubmit");
        const error = this.querySelector(".productV3PricingFormError");

        submit.classList.add("loading");
        error.textContent = "";

        // the fields plus the page context, so the request lands with the variant it was made from
        const formData = new FormData(this);
        formData.append("url", window.location.href);
        formData.append("product_title", product.title);
        formData.append("variant_title", activeVariant.title);

        const response = await fetch("https://api.audryrosejewelry.com/public/request-pricing.php", {
            method: "POST",
            body: JSON.stringify(Object.fromEntries(formData)),
        }).then(response => response.json());

        submit.classList.remove("loading");

        if (response.error) {
            error.textContent = `There was an error with your request: ${response.error}`;
            return;
        }

        // one state class swaps the form out for the confirmation
        pricing.classList.add("success");
    });

    /********************* Size Guide *********************/

    // the drawer and its trigger only render for a product with a bracelet size option
    const guide = section.querySelector(".productV3Guide");

    section.querySelector(".productV3OptionsGuide")?.addEventListener("click", function () {
        guide.showModal();
        document.body.classList.add("noScroll");
    });

    // close fires for the button, the backdrop and escape, so the scroll lock lifts in one place
    guide?.addEventListener("close", function () {
        document.body.classList.remove("noScroll");
    });

    guide?.querySelector(".productV3GuideHeaderClose").addEventListener("click", function () {
        guide.close();
    });

    // the inner panel swallows its own clicks, so a click on the dialog itself is the backdrop
    guide?.addEventListener("click", function (event) {
        if (event.target === guide) {
            guide.close();
        }
    });

    /********************* Info Dropdowns *********************/

    section.querySelectorAll(".productV3InfoDropdownTop").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /********************* Init *********************/

    // paint the first empty charm checkbox, then resolve the variant liquid started us on so the
    // image, price and stock all line up on load
    renderCharms();
    updateProduct();
}());
